export const T = {
  en_GB: { noPreference: "No preference" },
  nb_NO: { noPreference: "Ingen preferanse" },
} as const;
